export default function ExclusiveText() {
  return (
    <div id="about" className="p-5 md:p-20 flex flex-col justify-center sm:px-6 sm:text-center md:mx-auto md:max-w-2xl lg:col-span-6 lg:flex lg:items-center lg:text-left">
      <div className="p-10">
        <div className="flex justify-center items-center mt-20">
          <h1 className="text-center text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl flex-grow">
            EXCLUSIVE ACCESS TO <span className="text-[#26E2FF]">333</span>{" "}
            MEMBERS
          </h1>
        </div>
        <p className="mt-3  text-center text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry’s standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to.
        </p>
      </div>
    </div>
  );
}
